import { ReactComponent as ArrowCornerCcwLtSvg } from '@frontend/icons/arrow-corner-ccw-lt.svg';
import { ReactComponent as BookOpenSvg } from '@frontend/icons/book-open.svg';
import {
  Button,
  Icon,
  PhoneMockup,
  PhoneMockupBodyLayout,
  PhoneMockupLayout,
  Text,
  TextLink,
  WidgetHeader,
  WidgetHeaderContent,
  WidgetStatus,
} from '@frontend/ui-library';
import { getIdFromUrl } from '@frontend/utils';
import { useEffect } from 'react';

import links from '../../constants/links';
import { useWidgetContext } from '../../context/WidgetContext';
import { PageFields_CancelledPage_Fragment as PaymentCanceledPageFields } from '../../graphql/generated';
import { useRegisterHotjarPage } from '../../hooks';

export interface PaymentCanceledByMerchantProps {
  data: PaymentCanceledPageFields['cancelledPageData'];
}

const PaymentCanceledByMerchant = (props: PaymentCanceledByMerchantProps) => {
  const { configureHeader } = useWidgetContext();
  useRegisterHotjarPage('payment-canceled-by-merchant');

  useEffect(() => {
    configureHeader({
      id: getIdFromUrl(),
      merchantName: props.data?.merchantName || '',
    });
  }, []);

  return (
    <PhoneMockupLayout>
      <PhoneMockup
        header={
          <WidgetHeader color="error">
            <WidgetHeaderContent title="Error" />
          </WidgetHeader>
        }
      >
        <PhoneMockupBodyLayout
          bodyCentered
          body={
            <WidgetStatus
              emoji="😔"
              title="Payment canceled by merchant"
              description={
                <>
                  If you think this is a mistake please contact the merchant.
                  <br />
                  <br />
                  <Text as="div" size="inherit">
                    You will receive an email for the transactions <br /> that
                    meet{' '}
                    <TextLink
                      size="inherit"
                      href={links.support.REFUND_POLICY}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      our refund policy.
                    </TextLink>
                  </Text>
                </>
              }
            />
          }
          footer={
            <>
              <Button
                as="a"
                size="large"
                variant="ghost"
                href={links.UTRUST_HOME}
                rightIcon={<Icon component={<BookOpenSvg />} />}
              >
                Learn more
              </Button>
              {props.data?.cancelUrl && (
                <Button
                  as="a"
                  href={props.data.cancelUrl}
                  mt="16"
                  size="large"
                  variant="secondary"
                  rightIcon={<Icon component={<ArrowCornerCcwLtSvg />} />}
                >
                  Go back to store
                </Button>
              )}
            </>
          }
        />
      </PhoneMockup>
    </PhoneMockupLayout>
  );
};

export default PaymentCanceledByMerchant;
